import { render } from "./log-out.vue?vue&type=template&id=e3770064&ts=true"
import script from "./log-out.ts?vue&type=script&lang=ts"
export * from "./log-out.ts?vue&type=script&lang=ts"

import "./log-out.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/codebuild/output/src1311131323/src/codestar-connections.eu-central-1.amazonaws.com/git-http/030462892321/eu-central-1/15b42165-810b-4985-ad62-7e8e7752e7c2/studyportals/university-scheduler-overview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__